export const initialFilter = {
  search: "",
  category_id: undefined,
  subcategory_id: undefined,
  payment_term_id: undefined,
  project_type_id: undefined,
  location_id: undefined,
  min_price: 0,
  max_price: 0,
  skills: [], //warning empty
  legal_form_id: undefined,
  country_id: undefined,
  status: undefined,
}
export const sorts = [
  {id: 1, prop: "title", label: "NAME"},
  {id: 3, prop: "created_at", label: "CREATED_AT"},
  {id: 3, prop: "price", label: "PRICE"},
]